import React from 'react';
import { TextField, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {}
});

const BasicInfo = ({ firstName, lastName, email, password, passwordConfirm, step, onChanged }) => {
  const classes = useStyles({})
    ;
  return (
    <div className={classes.root}>
      <TextField
        label="First Name"
        required
        autoFocus
        fullWidth
        value={firstName}
        onChange={e => onChanged('firstName', e.target.value)}
        autoComplete="given-name"
        margin="normal"
      />
      <TextField
        label="Last Name"
        required
        fullWidth
        value={lastName}
        onChange={e => onChanged('lastName', e.target.value)}
        autoComplete="family-name"
        margin="normal"
      />

      <TextField
        label="Email Address"
        required
        fullWidth
        value={email}
        onChange={e => onChanged('email', e.target.value)}
        margin="normal"
      />

      <TextField
        label="Password"
        required
        fullWidth
        value={password}
        type="password"
        onChange={e => onChanged('password', e.target.value)}
        autoComplete="new-password"
        margin="normal"
      />

      <TextField
        label="Re-enter Password"
        required
        fullWidth
        value={passwordConfirm}
        type="password"
        onChange={e => onChanged('passwordConfirm', e.target.value)}
        autoComplete="new-password"
        margin="normal"
      />
    </div>
  );
};

export default BasicInfo;
